import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Kommunicate from '@kommunicate/kommunicate-chatbot-plugin';

Kommunicate.init("142a19ac7adc19a4aa19999167c728137",{"popupWidget":true,"automaticChatOpenOnNavigation":true})
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
